<div class="page-chat content-layout " fxLayout="column">

  <calsoft-page-header [height]="'180px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
  </calsoft-page-header>



  <div [formGroup]="firstFormGroup" class="container" fxFlex fxLayout="column">

    <calsoft-breadcrumbs [url]="'banner'" [currentPage]="'Banner'" [header]="'primary'">
    </calsoft-breadcrumbs>

    <div class="card" fxFlex fxLayout="column">
      <mat-drawer-container >

        <mat-drawer [mode]="mobileQuery.matches ? 'over' : 'side'" (openedChange)="drawerChange($event)"
          [opened]="drawerOpen$ | async" class="mat-elevation-z1 drawer" position="start">
          <div class="sidenav-container" fxFlex fxLayout="column">
            <div class="chat-toolbar " fxLayout="row" fxLayoutAlign="start center">
              <button [attr.guide]="'banner-advanced-btn-1' + '__' + sanitizedUrl" fxHide fxShow.gt-md fxShow.gt-sm matTooltip="Back" (click)="back()" mat-icon-button>
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
              <span fxHide fxShow.gt-md fxShow.gt-sm>Banner</span>
              <span fxHide fxShow.lt-md fxShow.lt-sm>Select a Tab</span>
              <span fxFlex>
              </span>
            </div>
            <calsoft-scrollbar class="flex-auto">
              <mat-nav-list class="chat-contacts">
                <mat-list-item class="chat-contact" *ngFor="let link of links; let i = index" (click)="menuLink(i)"
                  [class.highlighted]="i == menu">
                  <div fxLayoutAlign="start center">
                    <p class="name">{{ link.viewValue }}</p>
                  </div>
                </mat-list-item>
              </mat-nav-list>
            </calsoft-scrollbar>
          </div>
        </mat-drawer>
        <mat-drawer-content>

          <div class="chat-inner-container" fxLayout="column">
            <div class="chat-toolbar" fxLayout="row" fxLayoutAlign="start center">
              <button [attr.guide]="'banner-advanced-btn-2' + '__' + sanitizedUrl" fxHide fxShow.lt-md type="button" mat-icon-button (click)="openDrawer()">
                <mat-icon>menu</mat-icon>
              </button>
              <span fxHide fxShow.lt-md>Banner</span>
              <div class="current-contact" fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="column" fxLayoutAlign="center">
                  <span class="status"></span>
                </div>
              </div>
              <span fxFlex>
              </span>
              <div fxLayout="row" fxLayoutGap="10px">
                <!-- <button [attr.guide]="'banner-advanced-btn-3' + '__' + sanitizedUrl" mat-icon-button *ngIf="id != 0" (click)="audit('table')">
                                          <mat-icon>calendar_today</mat-icon>
                                      </button> -->
                <button [attr.guide]="'banner-advanced-btn-4' + '__' + sanitizedUrl" (click)="saveData()" [disabled]="text != 'Save'" mat-raised-button>
                  {{ text }}
                  <mat-icon *ngIf="text != 'Save'">
                    <mat-spinner color="primary" diameter="20"> </mat-spinner>
                  </mat-icon>
                </button>
              </div>

            </div>
            <div class="flex-auto overflow-hidden">

              <calsoft-scrollbar class="p-4  flex-auto">
                <div class="messages-container">
                  <div>
                    Banner to uploaded with width 1600 px and height 460px
                  </div>

                  <div>
                    <mat-form-field fxFlex>
                      <mat-label>Type</mat-label>
                      <mat-select required formControlName="type">
                        <mat-option *ngFor="let item of layout" [value]="item.viewValue">
                          {{ item.value }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>



                  <div *ngIf="menu ==0">
                    <div class="editSets">
                      <div class="title-head3" color="primary">
                        <span>Image</span>
                      </div>

                      <div id="responsieTable" class="container">
                        <table class="rwd-table">
                          <tbody>
                            <tr>
                              <th>Image</th>
                              <th>Filename</th>
                              <th>Category</th>
                              <th>Action</th>

                            </tr>


                            <ng-container formArrayName="images">
                              <tr *ngFor="let ImageInfo of firstFormGroup.get('images')['controls']; let i = index">
                                <ng-container [formGroupName]="i">
                                  <td data-th="Image">
                                    <!-- <img style="    height: 65px;
                                                              width: auto;"
                                      [src]="serverPath+ ImageInfo.controls['value'].value"
                                      onerror="this.src='assets/images/logo/no-image.png';" alt=""> -->

                                    <calsoft-common-images [src]="serverPath+ ImageInfo.controls['value'].value"
                                      [height]="'65px'" [width]="'auto'" [alt]="">

                                    </calsoft-common-images>
                                  </td>
                                  <td data-th="Filename">
                                    {{ ImageInfo.controls['value'].value}}
                                  </td>

                                  <td data-th="Category">
                                    <mat-form-field fxFlex>
                                      <mat-label>Category</mat-label>
                                      <mat-select required formControlName="category" [disableOptionCentering]="true"
                                        #singleSelect name="item">
                                        <mat-option>
                                          <ngx-mat-select-search name="Category Search" ngDefaultControl [formControl]="
                                                                    categoryFilterControl
                                                                  " placeholderLabel="Category Search"
                                            [preventHomeEndKeyPropagation]="
                                                                    true
                                                                  " noEntriesFoundLabel="No data found">
                                          </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="
                                                                  let opt of filteredCategoryTypeList
                                                                " [value]="opt.categoryId">
                                          {{ opt.categoryName }}
                                        </mat-option>
                                      </mat-select>

                                    </mat-form-field>
                                  </td>

                                  <td data-th="Action">
                                    <button [attr.guide]="'banner-advanced-btn-5' + '__' + sanitizedUrl" color="warn" mat-icon-button type="button"
                                      (click)="deleteImage( ImageInfo.controls['value'].value,i)">
                                      <mat-icon>remove_circle_outline
                                      </mat-icon>
                                    </button>

                                  </td>
                                </ng-container>
                              </tr>
                            </ng-container>

                          </tbody>
                        </table>
                      </div>



                    </div>
                    <div class="editSets1" *ngIf="writePermission">
                      <div class="title " fxLayout="row" fxLayoutAlign="center center">
                        <span *ngIf="firstFormGroup.value.images.length<=0" fxLayoutAlign="center center">No
                          Images
                          Uploaded</span>
                      </div>
                      <div>
                        <calsoft-common-file-upload (fileUploadResult)=getResult($event) [type]="'slider'">
                        </calsoft-common-file-upload>
                      </div>


                    </div>

                    <!-- <div
                      *ngIf="firstFormGroup.value.type=='type3' || firstFormGroup.value.type=='type4' || firstFormGroup.value.type=='type5' ||firstFormGroup.value.type=='type6' || firstFormGroup.value.type=='type7' || firstFormGroup.value.type=='type8'  ">

                      <calsoft-image-banner fxFlex (deleteResult)="update($event,'image1')" (fileUploadResult)="
                                    getResultSingeleImage($event,'image1')
                                    " [value]="firstFormGroup.value.image1"></calsoft-image-banner>

                      <calsoft-image-banner fxFlex (deleteResult)="update($event,'image2')" (fileUploadResult)="
                                  getResultSingeleImage($event,'image2')
                                  " [value]="firstFormGroup.value.image2"></calsoft-image-banner>
                      <calsoft-image-banner fxFlex (deleteResult)="update($event,'image3')" (fileUploadResult)="
                                  getResultSingeleImage($event,'image3')
                                  " [value]="firstFormGroup.value.image3"></calsoft-image-banner>

                    </div> -->

                    <div fxLayout="column"
                      *ngIf="firstFormGroup.value.type=='type3'||firstFormGroup.value.type=='type4' || firstFormGroup.value.type=='type5' || firstFormGroup.value.type=='type6' ">
                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                        <calsoft-image-banner fxFlex (deleteResult)="update($event,'image1')" (fileUploadResult)="
                                    getResultSingeleImage($event,'image1')
                                    " [value]="firstFormGroup.value.image1">
                        </calsoft-image-banner>

                        <calsoft-image-banner fxFlex (deleteResult)="update($event,'image2')" (fileUploadResult)="
                                  getResultSingeleImage($event,'image2')
                                  " [value]="firstFormGroup.value.image2">
                        </calsoft-image-banner>
                        <calsoft-image-banner fxFlex (deleteResult)="update($event,'image3')" (fileUploadResult)="
                                  getResultSingeleImage($event,'image3')
                                  " [value]="firstFormGroup.value.image3">
                        </calsoft-image-banner>
                      </div>

                    </div>

                    <!--  -->
                    <div fxLayout="column"
                      *ngIf="firstFormGroup.value.type=='type7'||firstFormGroup.value.type=='type8' || firstFormGroup.value.type=='type9' || firstFormGroup.value.type=='type10' ">
                      <div fxFlex fxLayout.gt-md="row" fxLayout.lt-md="column" fxLayoutGap="10">

                        <calsoft-image-banner fxFlex (deleteResult)="update($event,'image1')" (fileUploadResult)="
                                  getResultSingeleImage($event,'image1')
                                  " [value]="firstFormGroup.value.image1">
                        </calsoft-image-banner>

                        <calsoft-image-banner fxFlex (deleteResult)="update($event,'image2')" (fileUploadResult)="
                                getResultSingeleImage($event,'image2')
                                " [value]="firstFormGroup.value.image2">
                        </calsoft-image-banner>

                      </div>

                    </div>
                  </div>
                </div>


              </calsoft-scrollbar>
            </div>
          </div>
        </mat-drawer-content>

      </mat-drawer-container>

    </div>
  </div>


</div>